import React from 'react';

const reviews = [
  {
    text: '"Веснянки - це сім\'я! Ви моя підтримка 🥰 Найкраще ком\'юніті в світі! Найкращі спікери! Найкращі лекції! Найкращі мастермайнди! Найкращі зустрічі офлайн (Я так підозрюю, бо ще на жодній не була 😂) Найкращі зустрічі онлайн! 😏 Найкращі учасниці!"',
    avatar: '/images/avatar1.webp',
    name: 'Іра',
    info: 'Власниця агенції з нерухомості на Північному Кіпрі.',
    delay: 100,
  },
  {
    text: '"Навіть якщо тут не буде ніяких навчальних заходів, я все одно тут залишусь) Бо ви створили дуже дружню креативну атмосферу ❤️"',
    avatar: '/images/avatar2.webp',
    name: 'Юлія',
    info: 'Експертка з роздрібної торгівлі',
    delay: 200,
  },
  {
    text: '"Дякую нашим спікеркам за цікаві та пізнавальні лекції. Все передивилась в записі. 👌🏻❤️ Окреме дякую учасницям за те, що ви це ви)"',
    avatar: '/images/avatar3.webp',
    name: 'Іра',
    info: 'Психологиня',
    delay: 300,
  },
  {
    text: '"Готова кожній розповідати, аби дівчата приходили і змінювали своє життя, вікривали свої бізнеси і нічого не боялись, бо воно того варте. А разом з вами так взагалі ідеальніше і бути не може, бо де ви бачили простір, де можна отримати масу корисної інформації щодо ведення власного проєкту, постійну підтримку, віру і допомогу, класний вайб та такі неформальні зустрічі? Правильно ніде, тільки у Веснянка😘."',
    avatar: '/images/avatar4.webp',
    name: 'Ніка',
    info: 'Івент організаторка',
    delay: 400,
  },
];

export default function Reviews() {
  return (
    <section className="reviews" id="reviews">
      <h2>Відгуки наших учасниць</h2>
      <div className="reviews-grid">
        {reviews.map((r, i) => (
          <div className="review-card" data-aos="fade-up" data-aos-delay={r.delay} key={i}>
            <div className="review-content">
              <p className="review-text">{r.text}</p>
              <div className="review-author">
                <img src={r.avatar} alt={r.name} className="author-avatar" loading="lazy" width="48" height="48" />
                <div className="author-info">
                  <h3>{r.name}</h3>
                  <p>{r.info}</p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}